module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/_layout/content/content.component.css
// module id = ./src/app/_layout/content/content.component.css
// module chunks = main